<ng-template #Modal let-data let-ref="modalRef">
  <nb-card style="width: 100%">
    
    <div class="container">
      <div class="content-container"></div>
      <div class="title">
          <h2 style="text-align: center;color: #000;"><strong>出貨明細</strong></h2>
      </div>
      
      <div class="row">
        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xxl">
            <div class="input-group">
                <label class="label col-form-label">訂單編號　</label>
                <input name="condiTitleOrKeyword" type="text" class="form-control" 
                  [(ngModel)]="orderDetail.EOSNo" disabled ="true" />
            </div>
        </div>

        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xxl">
          <div class="input-group">
            <label class="label col-form-label">訂單日期　</label>
            <input name="condiTitleOrKeyword" type="text" class="form-control" 
              [(ngModel)]="orderDetail.CreateDate" disabled ="true" />
          </div>
        </div>
      </div>
      <div class="row mt-2">
          <div class="col-lg-12 col-md-10 col-xs-12 col-sm-10 test">
            <table class="table table-bordered table-striped">
              <thead>
                  <tr>
                      <th style="width : 70px;">項次</th>
                      <th>商品名稱</th>
                      <th style="width : 70px;">數量</th>
                      <th>單價</th>
                      <th>小計</th>
                      <!-- <th>預計出貨日</th> -->
                      <!-- <th>商家備註</th> -->
                  </tr>
              </thead>
              <tbody>
                  <tr *ngFor="let pd of orderDetail.PrintGetEOSInfoProductDTOs; let index = index">
                      <td>{{ index+1  }}</td>
                      <td>{{pd.EOSProductName}}</td>
                      <td>{{pd.Quantity}}</td>
                      <td>{{pd.EOSProductCash  | currency : null : true :'1.0'}}</td>
                      <td>{{pd.ProductTotalCash  | currency : null : true :'1.0'}}</td>
                      <!-- <td>{{ item.finalArrivalTimeString }}</td> -->
                      <!-- <td>{{ item.logisticsNote }}</td> -->

                  </tr>
              </tbody>
            </table>
          </div>
      </div>

      <div class="row" style="margin-top: 10px;">
        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xxl"></div>
        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xxl">
            <div class="input-group">
              <label class="label col-form-label">運費加總：　</label>
                <input name="condiTitleOrKeyword" type="text" class="form-control" 
                  [(ngModel)]="orderDetail.ShippingFee" 
                  style="width: -moz-available;" disabled ="true" />
            </div>
        </div>
      </div>

      
      <div class="row">
        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xxl"></div>
        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xxl">
            <div class="input-group">
              <label class="label col-form-label">總消費金額：</label>
              <input name="condiTitleOrKeyword" type="text" class="form-control" 
                [(ngModel)]="orderDetail.TotalCash" 
                style="width: -moz-available;" disabled ="true" />
            </div>
        </div>
      </div>

      
      <div class="row" style="margin-top: 30px;">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xxl">
            <div class="input-group">
              <label class="label col-form-label">訂購人資訊</label>
            </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xxl">
            <div class="input-group">
                <label class="label col-form-label">姓名：　　　</label>
                <label class="label col-form-label">
                  <strong>{{ orderDetail.Name ? orderDetail.Name : '無'}}</strong></label>
            </div>
        </div>
      </div>

      <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xxl">
              <div class="input-group">
                  <label class="label col-form-label">手機號碼：&emsp;&emsp;</label>
                  <label class="label col-form-label">
                    <strong>{{ orderDetail.Phone ? orderDetail.Phone : '無'}}</strong></label>
              </div>
          </div>
      </div>
      <div class="row">
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xxl">
              <div class="input-group">
                  <label class="label col-form-label">地址：　　　</label>
                  <label class="label col-form-label">
                    <strong>{{ orderDetail.Address ? orderDetail.Address : '無'}}</strong></label>
              </div>
          </div>
      </div>
    </div>
  </nb-card>
</ng-template>